"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
/** @jsxFrag */
const core_1 = require("@emotion/core");
const constants_1 = require("@/constants");
const styles_1 = __importDefault(require("./styles"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const Footer = ({ children, justifyContent, gap }) => (core_1.jsx("div", { className: styles_scss_1.default.modalFooter, css: styles_1.default.footer(justifyContent, gap), "aria-label": 'Modal Footer' }, children));
Footer.defaultProps = {
    justifyContent: 'flex-end',
    gap: 12
};
const ModalTemplate = (props) => {
    const { width, title, ariaLabel, onClose, children } = props;
    const onContentClick = (e) => {
        e.stopPropagation();
    };
    return (core_1.jsx("div", { className: styles_scss_1.default.modalOverlay, onClick: onClose, onKeyPress: onClose, role: "button", tabIndex: 0 },
        core_1.jsx("div", { className: styles_scss_1.default.modalContainer, css: styles_1.default.container(width), "aria-label": ariaLabel, onClick: onContentClick, onKeyPress: onContentClick, role: "button", tabIndex: -1 },
            core_1.jsx("div", { className: styles_scss_1.default.modalHeader, role: "button", "aria-label": 'Modal Header', onClick: onClose, onKeyPress: onClose, tabIndex: -2 },
                core_1.jsx("h4", null, title),
                core_1.jsx("img", { src: constants_1.Images.greyClose, alt: 'Close Button' })),
            core_1.jsx("div", { className: styles_scss_1.default.modalContent, "aria-label": 'Modal Content' }, children))));
};
ModalTemplate.defaultProps = {
    title: '',
    ariaLabel: 'Modal',
    width: 600
};
ModalTemplate.Footer = Footer;
exports.default = ModalTemplate;
